import { Card, CardBody, Col } from "reactstrap";
import NegativeValueForm from "./NegativeValueForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { NegativeRangeTitle } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const NegativeValue = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={NegativeRangeTitle} span={BasicSliderData} />
        <CardBody>
          <NegativeValueForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default NegativeValue;
